import { render } from "./LinkRequestingOrders.vue?vue&type=template&id=020a5d84&scoped=true"
import script from "./LinkRequestingOrders.vue?vue&type=script&lang=js"
export * from "./LinkRequestingOrders.vue?vue&type=script&lang=js"

import "./LinkRequestingOrders.vue?vue&type=style&index=0&id=020a5d84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020a5d84"]])

export default __exports__